var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { connect } from 'react-redux';
import * as TemplateFactory from '../../classes/definitions/template/template';
import ApiRequests from '../../classes/http/ApiRequests';
import HttpRequests from '../../classes/http/HttpRequests';
import TemplateList from '../../components/Template/TemplateList/TemplateList';
import AppRoutes from '../../config/appRoutes';
import TemplateReduxProps from './TemplateReduxProps';
var Templates = /** @class */ (function (_super) {
    __extends(Templates, _super);
    function Templates() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.queryParams = { pageNumber: 1, filter: '' };
        _this.state = {
            data: [],
            meta: null,
            delayTemplateTimer: null,
        };
        _this.getTemplates = function (pageNum) {
            _this.api
                .getTemplates()
                .then(function (response) {
                var templates = TemplateFactory.createTemplates(response.data.data);
                _this.setState({ data: templates });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим списъка с продукти', _this.props.history);
            });
        };
        _this.toNewTemplate = function () {
            _this.props.history.push(AppRoutes.template.path);
        };
        // Deleting the item from the state
        _this.deleteItem = function (id) {
            var data = __spreadArrays(_this.state.data);
            var result = data.find(function (item) {
                return id;
            });
            var index = data.indexOf(result);
            data.splice(index, 1);
            _this.setState({ data: data });
        };
        return _this;
    }
    Templates.prototype.componentDidMount = function () {
        this.getTemplates(1);
    };
    Templates.prototype.render = function () {
        var _this = this;
        var data = this.state.data;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn templatesClass" },
                React.createElement("h1", { className: "display-3" }, "\u0428\u0430\u0431\u043B\u043E\u043D\u0438 \u0437\u0430 \u041D\u0430\u0447\u0430\u043B\u043D\u0430 \u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0430"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewTemplate, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432\u043E \u0428\u0430\u0431\u043B\u043E\u043D")),
                        React.createElement(Messages, { ref: function (el) {
                                _this.messages = el;
                            } }),
                        React.createElement(TemplateList, { gridData: data, getAllTemplates: this.getTemplates, messages: this.messages, deleteItem: this.deleteItem }))))));
    };
    return Templates;
}(React.Component));
export default connect(null, TemplateReduxProps.mapDispatchToProps)(Templates);



//////////////////
// WEBPACK FOOTER
// ./src/views/Templates/Templates.tsx
// module id = 490
// module chunks = 0